
import { Component, Mixins, Watch } from 'vue-property-decorator';
import ResponsivenessMixin from '@/features/common/mixins/responsivenessMixin';
import { NotificationMixin } from '../mixins';

@Component
export default class General extends Mixins(NotificationMixin, ResponsivenessMixin) {
  private formData = {
    isHideDonNotShowOption: {
      show: true,
      name: 'HideDoNotShow',
    },
  }

  get isTablet(): boolean {
    return this.$vuetify.breakpoint.lgAndDown;
  }

  @Watch('isNotificationPrefs', { immediate: true })
  private populatePreferences(newValue: boolean) {
    if (newValue) {
      this.formData.isHideDonNotShowOption.show = this.searchNotificationPref(
        this.formData.isHideDonNotShowOption.name,
      );
    }
  }
}
